import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const ModelName = styled.h3`
    margin-bottom: ${theme.space[1]}px;
    font-family: ${theme.fonts.regular};
    font-size: 2.8rem;
    line-height: 3.2rem;
    color: ${theme.colors.primaryBlack};
`;

export const EngineName = styled.p`
    margin-bottom: ${theme.space[2]}px;
    font-family: ${theme.fonts.base};
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${theme.colors.grey7};
`;

export const Description = styled.p`
    margin-bottom: ${theme.space[2]}px;
    font-family: ${theme.fonts.base};
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${theme.colors.grey7};
`;

export const Price = styled.p`
    margin-top: ${theme.space[3]}px;
    margin-bottom: ${theme.space[5]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.6rem;
    line-height: 2.4rem;
`;

export const Actions = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: ${theme.space[2]}px;
    padding-top: ${theme.space[3]}px;
    border-top: 1px solid ${theme.colors.grey2};
`;
